/* MCC footer: accordions, back-to-top button, chat opener and newsletter sign-up.
   Moved from sections/custom-footer.liquid and layout/theme.liquid so browsers can cache them (6 Oct 2026). */

(function() {
  var triggers = document.querySelectorAll('.mcc-footer__accordion-trigger');
  
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all others
      triggers.forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
      
      // Toggle current
      this.setAttribute('aria-expanded', !expanded);
    });
  });
  
  // Handle resize - reset accordions on desktop
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > 749) {
        triggers.forEach(function(trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
    }, 250);
  });
  
  // Back to top functionality
  var backToTopBtn = document.querySelector('.mcc-footer__back-to-top[data-threshold]');
  
  if (backToTopBtn) {
    var showThreshold = parseInt(backToTopBtn.getAttribute('data-threshold'), 10) || 0;
    var hasText = backToTopBtn.querySelector('.mcc-footer__back-to-top-text');
    
    if (hasText && hasText.textContent.trim() !== '') {
      backToTopBtn.classList.add('has-text');
    }
    
    // Show/hide based on scroll position
    function toggleBackToTop() {
      if (window.scrollY > showThreshold) {
        backToTopBtn.classList.add('visible');
      } else {
        backToTopBtn.classList.remove('visible');
      }
    }
    
    // Throttled scroll listener
    var scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (!scrollTicking) {
        window.requestAnimationFrame(function() {
          toggleBackToTop();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    });
    
    // Scroll to top on click
    backToTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    
    // Initial check
    toggleBackToTop();
  }


  // Chat opener: opens the Shopify Inbox widget from any [data-action="open-chat"] element on the page
  function openShopifyChat() {
    var inbox = document.querySelector('shopify-chat');
    var root = inbox && inbox.shadowRoot;
    var btn = root && (root.querySelector('button.activator') || root.querySelector('button'));
    if (btn) { btn.click(); return true; }
    if (typeof tidioChatApi !== 'undefined') { tidioChatApi.open(); return true; }
    return false;
  }

  if (!window.mccChatHandlerBound) {
    window.mccChatHandlerBound = true;
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-action="open-chat"]');
      if (!trigger) return;
      e.preventDefault();
      openShopifyChat();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var trigger = e.target.closest('[data-action="open-chat"]');
      if (!trigger || trigger.tagName === 'BUTTON' || trigger.tagName === 'A') return;
      e.preventDefault();
      openShopifyChat();
    });
  }
})();

/* Footer newsletter sign-up (moved from layout/theme.liquid) */
    document.addEventListener('DOMContentLoaded', function() {
      var footerForm = document.querySelector('form.mcc-footer__newsletter-form');
      if (!footerForm) return;

      var emailInput = footerForm.querySelector('input[type="email"], input[name="contact[email]"]');
      var submitBtn = footerForm.querySelector('button[type="submit"], input[type="submit"]');
      var successMsg = footerForm.querySelector('.mcc-footer__newsletter-success') || null;

      footerForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) return;

        // Disable button during submission
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Subscribing...'; }

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=U3nWnd', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED',
                            consent_source: 'Footer Newsletter Form',
                            consent_landing_page: window.location.href
                          }
                        }
                      }
                    }
                  }
                },
                list_id: 'XtzsJK'
              }
            }
          })
        })
        .then(function(response) {
          if (response.status === 202 || response.ok) {
            // Success - show success message
            footerForm.innerHTML = '<p style="color:#fff;font-size:16px;padding:10px 0;">Thanks for subscribing! Check your inbox for a confirmation email.</p>';
          } else {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Subscribe'; }
            alert('Something went wrong. Please try again.');
          }
        })
        .catch(function() {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Subscribe'; }
          alert('Something went wrong. Please try again.');
        });
      });
    });
  